import React, { useState, useEffect } from 'react';
import { Input, Tooltip } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import useDebounce from 'hooks/useDebounce';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import style from './SearchField.module.scss';

type TDelay = 0 | 800;

interface ISearchField {
	onChangeSelectSearchString: (value: string) => void;
	searchString: string;
	className?: string;
	delay?: TDelay;
}

const SearchField: React.FC<ISearchField> = ({ onChangeSelectSearchString, searchString, className, delay = 0 }) => {
	const [searchTerm, setSearchTerm] = useState('');
	const debouncedSearchTerm = useDebounce(searchTerm, delay);
	const { t } = useTranslation('global');

	const searchInputClasses = classNames(style.searchInput, className);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearchTerm?.(e.target.value);
	};

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		e.stopPropagation();
	};

	useEffect(() => {
		onChangeSelectSearchString(debouncedSearchTerm);
	}, [debouncedSearchTerm]);

	useEffect(() => {
		setSearchTerm(searchString);
	}, [searchString]);

	return (
		<Input
			className={searchInputClasses}
			onChange={handleChange}
			value={searchTerm}
			onKeyDown={handleKeyDown} // To fix cleanup dishes multiple select when press backspace
			allowClear={true}
			placeholder={t('searchPlaceholder')}
			suffix={
				<Tooltip title={t('searchPlaceholder')}>
					<SearchOutlined className={style.searchIcon} />
				</Tooltip>
			}
			data-test="SearchField"
		/>
	);
};

export default React.memo(SearchField);
